<div class="admin-container">
  <section>
    <h3>{{ title }}</h3>
    <div [innerHTML]="text"></div>
  </section>
</div>
